(function () {
  // ---- CONFIG ----
  var THRESHOLD = 12000;              // £120.00 in pence
  var GIFT_VARIANT = 56730964197762;  // "Your Free Gift" variant ID
  var GIFT_QTY = 1;
  var TOAST_TEXT = 'Free gift unlocked! A little something added to your bag.';
  var TOAST_DURATION = 4500;

  // Master switches:
  // FORCE_OFF = true instantly disables everything regardless of product status.
  // Otherwise the feature only runs when the gift product is purchasable
  // (set "Your Free Gift" product to Draft to switch the whole offer off).
  var FORCE_OFF = false;
  var GIFT_HANDLE = 'your-free-gift'; // product handle, used to check availability
  // ----------------

  var working = false;
  var giftActive = false; // resolved at runtime from product availability

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  // Is the offer live? FORCE_OFF overrides; otherwise check product availability.
  function checkGiftActive() {
    if (FORCE_OFF) return Promise.resolve(false);
    return fetch('/products/' + GIFT_HANDLE + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { return !!(p && p.available); })
      .catch(function () { return false; });
  }

  function giftInCart(cart) {
    return cart.items.some(function (item) {
      return item.variant_id === GIFT_VARIANT;
    });
  }

  // Subtotal excluding the gift itself
  function nonGiftSubtotal(cart) {
    return cart.items.reduce(function (sum, item) {
      if (item.variant_id === GIFT_VARIANT) return sum;
      return sum + item.final_line_price;
    }, 0);
  }

  function addGift() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: GIFT_VARIANT, quantity: GIFT_QTY }] })
    }).then(function (r) { return r.ok; }).catch(function () { return false; });
  }

  function removeGift() {
    var updates = {};
    updates[GIFT_VARIANT] = 0;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    });
  }

  function showToast() {
    var existing = document.getElementById('free-gift-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.id = 'free-gift-toast';
    toast.className = 'free-gift-toast color-scheme color-scheme--scheme-3';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML =
      '<span class="free-gift-toast__icon" aria-hidden="true"></span>' +
      '<span class="free-gift-toast__text">' + TOAST_TEXT + '</span>';

    document.body.appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });

    setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { if (toast.parentNode) toast.remove(); }, 400);
    }, TOAST_DURATION);
  }

  function refreshCartUI() {
    var sections = ['cart-drawer', 'cart-icon-bubble', 'cart-live-region-text', 'main-cart-items', 'main-cart-footer'];
    return fetch('/?sections=' + sections.join(','))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        sections.forEach(function (name) {
          if (!data[name]) return;
          document.querySelectorAll('[id^="' + name + '"], #' + name).forEach(function (el) {
            try {
              var html = new DOMParser().parseFromString(data[name], 'text/html');
              var fresh = html.querySelector('#' + el.id) || html.body.firstElementChild;
              if (fresh) el.innerHTML = fresh.innerHTML;
            } catch (e) {}
          });
        });
        document.dispatchEvent(new CustomEvent('free-gift:updated'));
      });
  }

  function evaluate() {
    if (working) return;
    working = true;

    getCart().then(function (cart) {
      var subtotal = nonGiftSubtotal(cart);
      var hasGift = giftInCart(cart);

      // If the offer is off, make sure no stray gift lingers, then stop.
      if (!giftActive) {
        if (hasGift) return removeGift().then(refreshCartUI);
        return;
      }

      if (subtotal >= THRESHOLD && !hasGift) {
        return addGift().then(function (ok) {
          if (ok) { showToast(); return refreshCartUI(); }
        });
      } else if (subtotal < THRESHOLD && hasGift) {
        return removeGift().then(refreshCartUI);
      }
    }).finally(function () {
      working = false;
    });
  }

  var nativeFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var isCartChange = typeof url === 'string' &&
      /\/cart\/(add|change|update|clear)/.test(url);
    var result = nativeFetch.apply(this, arguments);
    if (isCartChange) {
      result.then(function () { setTimeout(evaluate, 300); });
    }
    return result;
  };

  // ---- FREE GIFT badge ----
  function decorateFreeGifts() {
    if (!giftActive) return;
    var lines = document.querySelectorAll('.line-item');

    lines.forEach(function (line) {
      var info = line.querySelector('.line-item-info') || line;
      var text = (line.textContent || '');

      // Identify the gift line: by £0.00 OR by the gift title
      var isFree = /£\s*0\.00/.test(text) || /your free gift/i.test(text);

      var already = line.querySelector('.free-gift-badge');

      if (isFree && !already) {
        var badge = document.createElement('span');
        badge.className = 'free-gift-badge';
        badge.innerHTML =
          '<svg aria-hidden="true" focusable="false" fill="none" width="12" viewBox="0 0 24 24">' +
          '<path d="M22.707 12.293l-11-11A1.002 1.002 0 0 0 11 1H2a1 1 0 0 0-1 1v9c0 .265.105.52.293.707l11 11a.997.997 0 0 0 1.414 0l9-9a.999.999 0 0 0 0-1.414zM7 9a2 2 0 1 1-.001-3.999A2 2 0 0 1 7 9z" fill="currentColor"></path>' +
          '</svg>FREE GIFT';
        info.appendChild(badge);
      } else if (!isFree && already) {
        already.remove();
      }
    });
  }

  // ---- FREE GIFT progress message (cart drawer) ----
  function formatGBP(pence) {
    return '£' + (pence / 100).toFixed(2);
  }

  function renderProgress() {
    if (!giftActive) {
      var old = document.getElementById('free-gift-progress');
      if (old) old.remove();
      return;
    }

    getCart().then(function (cart) {
      var subtotal = nonGiftSubtotal(cart);
      var remaining = THRESHOLD - subtotal;

      var drawerItems = document.querySelector('.cart-drawer__items, cart-drawer .drawer__inner, .cart-drawer');
      if (!drawerItems) return;

      var bar = document.getElementById('free-gift-progress');
      if (!bar) {
        bar = document.createElement('div');
        bar.id = 'free-gift-progress';
        bar.className = 'free-gift-progress';
        drawerItems.insertBefore(bar, drawerItems.firstChild);
      }

      var pct = Math.min(100, Math.round((subtotal / THRESHOLD) * 100));

      if (remaining > 0) {
        bar.innerHTML =
          '<p class="free-gift-progress__text">Spend <strong>' + formatGBP(remaining) +
          '</strong> more to unlock your free gift</p>' +
          '<div class="free-gift-progress__track"><div class="free-gift-progress__fill" style="width:' + pct + '%"></div></div>';
        bar.classList.remove('is-complete');
      } else {
        bar.innerHTML =
          '<p class="free-gift-progress__text">You have unlocked your free gift</p>' +
          '<div class="free-gift-progress__track"><div class="free-gift-progress__fill" style="width:100%"></div></div>';
        bar.classList.add('is-complete');
      }
    });
  }

  // ---- Hide purchase controls on the gift product page ----
  function hideGiftProductButtons() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach(function (form) {
      var idInput = form.querySelector('[name="id"]');
      if (idInput && String(idInput.value) === String(GIFT_VARIANT)) {
        var buyArea = form.querySelector('buy-buttons') ||
                      form.querySelector('.product-form__buttons') || form;
        if (buyArea) buyArea.style.display = 'none';
      }
    });
    document.querySelectorAll('buy-buttons').forEach(function (bb) {
      if (new RegExp(String(GIFT_VARIANT)).test(bb.outerHTML)) bb.style.display = 'none';
    });
  }

  // ---- Wiring ----
  document.addEventListener('free-gift:updated', function () {
    setTimeout(function () { decorateFreeGifts(); renderProgress(); }, 100);
  });

  function watchCart() {
    var target = document.querySelector('cart-drawer, .cart-drawer, #CartDrawer') || document.body;
    var observer = new MutationObserver(function () {
      decorateFreeGifts();
      renderProgress();
    });
    observer.observe(target, { childList: true, subtree: true });
    decorateFreeGifts();
    renderProgress();
  }

  function init() {
    // Always hide gift-product buttons (cheap, runs regardless of offer state).
    hideGiftProductButtons();

    checkGiftActive().then(function (active) {
      giftActive = active;
      watchCart();
      evaluate();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();